import { useDispatch } from 'react-redux';

import {
  setFeatureFlags,
  getAmplitudeFeatureFlags,
} from 'store/actions/featureFlag';

function useFeatureFlag() {
  const dispatch = useDispatch();

  function fetchFeatureFlags({ userId, auth, orgId }) {
    setTimeout(() => {
      dispatch(setFeatureFlags({ userId, auth, orgId }));
    }, 1000);
    dispatch(getAmplitudeFeatureFlags({ userId, auth, orgId }));
  }

  return { fetchFeatureFlags };
}

export default useFeatureFlag;
